import store from '../../../index';

export default {
    namespaced: true,
    state: {
        currentContent360: {},
        defaultContent360: {
            file: {
                path: '',
                name: ''
            },
            north: false,
            alphaOffset: '0'
        }
    },

    getters: {
        defaultContent360: (state) => {
            return state.defaultContent360;
        }
    },

    mutations: {
        SET_DATA: (state, data) => {
            state.currentContent360 = Object.assign({}, state.currentContent360, data);
        },
        CLEAN_CURRENT_DATA: (state) => {
            state.currentContent360 = {};
        }
    },

    actions: {
        content360Update: function (localStore) {
            return new Promise(function (resolve, reject) {
                let value = { ...localStore.state.currentContent360 };
                store.dispatch('actions/updateActionData', value).then(() => {
                    resolve();
                }).catch((err) => {
                    reject(err);
                });
            });
        }
    }
};
